import { RuleSetRules } from '../EntityPages';

export const RuleSetRulesTab = () => {
  return <RuleSetRules />;
};
